import React from 'react';
import { Icon } from 'antd';
import msLogo from '../../assets/images/home/ms-blue-logo.svg';
import './../../assets/scss/components/Common/ServerDownPage.scss';

const ServerDownPage = ({ subText }) => {
    return (
        <div className="server-down-wrapper">
            <div className="server-down-logo">
                <img src={msLogo} alt="MillionSpaces" />
            </div>
            <div className="server-down-content">
                <div className="server-down-icon-container">
                    <div className="icon-pulse-glow" />
                    <Icon type="cloud-server" className="server-down-icon-server" />
                    <Icon type="disconnect" className="server-down-icon-plug" />
                </div>
                <h1 className="server-down-title">We'll Be Right Back</h1>
                <p className="server-down-subtitle">
                    {subText || "Our servers are taking a short break. We're working hard to get things back up and running as quickly as possible."}
                </p>
                <div className="server-down-actions">
                    <button className="server-down-retry-btn" onClick={() => window.location.reload()}>
                        Try Again
                    </button>
                </div>
                <div className="server-down-footer">
                    <p>If this issue persists, please contact our support team.</p>
                </div>
            </div>
        </div>
    );
};

export default ServerDownPage;
